import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

import { Report, ReportFormType } from '../types/types';

const mock: Report[] = [
  {
    id: '1',
    name: 'Сальдо/Фінанси',
    formType: ReportFormType.BalanceFinance,
    description:
      'Загальний фінансовий стан по абонентам за обраний період: нарахування, оплати, борги, переплати та кінцеве сальдо',
    lastGenerationDate: '2024-01-05T15:45:00',
    authorName: 'Автор',
  },
  {
    id: '2',
    name: 'Реєстр боржників',
    formType: ReportFormType.DebtorRegistry,
    description:
      'Перелік абонентів з заборгованістю з детальною вибіркою боргу, типу споживання та статусу рахунку',
    lastGenerationDate: '2024-01-05T15:45:00',
    authorName: 'Автор',
  },
  {
    id: '3',
    name: 'Нарахування абонентів',
    formType: ReportFormType.SubscriberCharges,
    description:
      'Дані про нарахування абонентам за природний газ для побутових та комерційних споживачів за обраний період',
    lastGenerationDate: '2024-01-05T15:45:00',
    authorName: 'Автор',
  },
  {
    id: '4',
    name: 'Нерозподілені оплати',
    formType: ReportFormType.UndistributedPayments,
    description:
      'Оплати, що не були зараховані на конкретні особові рахунки абонентів',
    lastGenerationDate: '2024-01-05T15:45:00',
    authorName: 'Автор',
  },
  {
    id: '5',
    name: 'Платежі',
    formType: ReportFormType.Payments,
    description:
      'Інформація про всі платежі по абонентам з розбивкою за джерелами надходжень',
    lastGenerationDate: '2024-01-05T15:45:00',
    authorName: 'Автор',
  },
];

const adapter = new AxiosMockAdapter(instance);

adapter
  .onGet(/\/api\/reports.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
